import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=012a6039&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=012a6039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a6039",
  null
  
)

export default component.exports